module.exports = __webpack_public_path__ + "img/AM_Labor-Day-2022.ecd9628e.jpg";